module.exports = __webpack_public_path__ + "img/phones_withbg.9f4ed942.png";